/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.identity.updateHandle";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"handle":/*#__PURE__*/ l.string({"format":"handle"})});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.payload();

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Updates the current account's handle. Verifies handle validity, and updates did:plc document if necessary. Implemented by PDS, and requires auth. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output);

export { main };

export const $lxm = $nsid;
